const installation = {
  noConfigurableParameters: "No configurable parameters for this flow.",
  noPromptsConfigured: "No prompts configured for this flow.",
  promptSection: "Section",
  promptSections: "Prompt Sections",
  promptSectionTitle: "Section title",
  promptPlaceholder: "Enter prompt content...",
  promptHint: "You can review and customize this prompt as needed",
  promptBlocked: "This prompt is locked and cannot be edited",
  promptAddSection: "Add Section",
  promptAddFirstSection: "Add First Section",
  promptRemoveSection: "Remove section",
  promptNewSection: "New Section",
  successTitle: "Flow Installed Successfully!",
  successMessage: "The flow {{workflow}} has been successfully installed and configured in your workspace.",
  triggerGenerated: "Trigger Generated",
  readyToInstall: "Ready to install!",
  readyDescription: "Your settings have been validated and the flow is ready to be installed.",
  installationInProgress: "Installation in progress...",
  installationFailed: "Installation failed.",
  installationComplete: "Installation complete!",
  installationCancelled: "Installation cancelled.",
  install: "Install",
  nextStep: "Next",
  previousStep: "Previous",
  cancel: "Cancel",
  wizardDescription: "This wizard will guide you through the flow installation process.",
  installing: "Installing...",
  close: "Close",
  stepIndicator: "Step {{current}} of {{total}}",

  installationProcess: {
    copying: "Copying...",
    integrations: "Integrating...",
    parameters: "Parametrizing...",
    publishing: "Publishing...",
    exporting: "Exporting...",
    finalizing: "Finalizing...",
    currentStep: "Preparing installation...",
    workflow: "Preparing flow...",
    triggerGenerated: "Trigger generated successfully!",
    finishing: "Finishing Installation...",
    finished: "Installation Finished!"
  },

  warnings: {
    triggerNotSaved:
      "The flow was installed, but its main trigger could not be saved. Open the flow settings and save the trigger again.",
    secretNotStored:
      "The flow was installed, but a credential could not be stored securely, so it was not saved at all. Open the flow settings and enter it again.",
  },

};

export default installation;
